import { t } from 'i18next';
import { useEffect, useState } from 'react';

import CreateProjectDropdown from '../../components/DropdownStyle/CreateProjectDropdown';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import ReactSelectDropdown from '../../components/ReactSelectDropdown';
import { filterOption } from '../../components/ReactSelectDropdown/ReactSelectDropdown';
import {
  CommonFlex,
  CommonText,
  Container,
  FilterLabel,
  InputWithLabelSection,
  PageTitle,
} from '../../styledComponents/common';
import ItemTransactionChart from './ItemTransactionChart';

const ItemTransactionsDashboard = ({
  officesShortList,
  itemsList,
  getOfficesShortList,
  getItemsList,
  itemTransactionsDashboardData = [],
  getItemTransactionsDashboardData,
  isLoading,
}) => {
  const [selectedOffice, setSelectedOffice] = useState({
    label: t('all_offices'),
    value: null,
  });
  const [selectedItem, setSelectedItem] = useState({
    label: t('all_items'),
    value: null,
  });

  const [officeOptions, setOfficeOptions] = useState([
    { label: t('all_offices'), value: null },
  ]);
  const [itemOptions, setItemOptions] = useState([
    { label: t('all_items'), value: null },
  ]);

  useEffect(() => {
    getOfficesShortList();
    getItemsList();
  }, []);

  useEffect(() => {
    const payload = {};
    if (selectedOffice?.value) {
      payload.office_id = selectedOffice.value;
    }
    if (selectedItem?.value) {
      payload.item_id = selectedItem.value;
    }
    if (payload.office_id || payload.item_id) {
      getItemTransactionsDashboardData(payload);
    }
  }, [selectedOffice, selectedItem]);

  useEffect(() => {
    if (officesShortList?.length) {
      const options = [
        { label: t('all_offices'), value: null },
        ...officesShortList.map(office => ({
          label: office.name,
          value: office.id,
        })),
      ];
      setOfficeOptions(options);
    }
  }, [officesShortList]);

  useEffect(() => {
    if (itemsList?.length) {
      const itemsArray = itemsList.map(item => ({
        label: item.name,
        value: item.id,
      }));

      const options = selectedOffice?.value
        ? [{ label: t('all_items'), value: null }, ...itemsArray]
        : itemsArray;

      setItemOptions(options);
    }
  }, [itemsList, selectedOffice]);

  useEffect(() => {
    if (
      !selectedOffice?.value &&
      itemOptions?.length &&
      selectedItem?.value === null
    ) {
      const item = itemOptions.find(item => {
        return item.value;
      });
      if (item) {
        setSelectedItem(item);
      }
    }
  }, [selectedOffice, itemOptions]);

  const handleOfficeChange = selectedOption => {
    setSelectedOffice(selectedOption);
    selectedOption?.value &&
      setSelectedItem({
        label: t('all_items'),
        value: null,
      });
  };

  return (
    <div className="content">
      <PageTitle>{t('items_transactions_dashboard')}</PageTitle>
      <Container padding="30px">
        <CommonText name title fontSize="20px">
          {t('items_transactions_dashboard')}
        </CommonText>
        <CommonFlex gap="20px" margin="20px 0">
          <InputWithLabelSection
            width="200px"
            style={{
              zIndex: 6,
            }}
          >
            <FilterLabel>{t('office')}</FilterLabel>
            <ReactSelectDropdown
              isSearchable={false}
              value={selectedOffice}
              options={officeOptions}
              placeholder={t('select_office')}
              onChange={handleOfficeChange}
              styles={CreateProjectDropdown()}
              filterOption={filterOption}
            />
          </InputWithLabelSection>
          <InputWithLabelSection
            width="200px"
            style={{
              zIndex: 6,
            }}
          >
            <FilterLabel>{t('item')}</FilterLabel>
            <ReactSelectDropdown
              isSearchable={false}
              value={selectedItem}
              options={itemOptions}
              placeholder={t('select_item')}
              onChange={setSelectedItem}
              styles={CreateProjectDropdown()}
              filterOption={filterOption}
            />
          </InputWithLabelSection>
        </CommonFlex>
        {isLoading ? (
          <ComponentCircleLoader />
        ) : (
          <ItemTransactionChart
            itemTransactionsDashboardData={itemTransactionsDashboardData}
          />
        )}
      </Container>
    </div>
  );
};

export default ItemTransactionsDashboard;
